module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel05_1280_1280_ja-0e3ab16d97fdd2a6b7330d4ff50ef0ca.jpg";